/**
 * GENERATED - DO NOT EDIT.
 * TypeScript types and constants for the oathera.telemetry contract.
 * Source: packages/contract/catalog/*.yaml. Regenerate with `npm run contract:generate`.
 * Contract version: 1.7
 * Schema: oathera.telemetry/1
 * Catalog hash: sha256-DzNmv0VzzBBPBNTAWI7HhHTnkWd1WstQzV64Bzc6KJU
 */

export const CONTRACT_VERSION = "1.7" as const;
export const SCHEMA_ID = "oathera.telemetry/1" as const;
export const CATALOG_HASH = "sha256-DzNmv0VzzBBPBNTAWI7HhHTnkWd1WstQzV64Bzc6KJU" as const;

/** Numeric limits of the wire format (design 4.6). Defined once, in the catalog `limits`. */
export const LIMITS = {
  maxSeriesPerMetric: 50,
  maxAttrsPerEvent: 32,
  maxStringLength: 256,
  maxBodyBytes: 102400,
  maxEventsPerBatch: 500,
  maxSpansPerBatch: 500,
  maxMetricPointsPerBatch: 2000,
  minFlushIntervalMs: 1000,
  maxFlushIntervalMs: 60000,
  defaultFlushIntervalMs: 10000,
  securityFlushMs: 1000,
  maxPostureEntriesPerBatch: 200,
  maxPostureFindings: 16,
  maxSigningKeys: 8,
  maxEpochs: 8,
  maxAuditEntriesPerBatch: 1000,
} as const;

export const SERVICES = ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"] as const;
export type Service = (typeof SERVICES)[number];

export const SEVERITIES = ["info", "warn", "error", "critical"] as const;
export type Severity = (typeof SEVERITIES)[number];

/** Upper bounds in milliseconds. A +Inf bucket is implicit: N bounds mean N + 1 counts. */
export const HISTOGRAM_BOUNDARIES = {
  default_ms: [1, 2, 5, 10, 25, 50, 100, 250, 500, 1000, 2500, 5000],
} as const;
export type HistogramBoundarySet = keyof typeof HISTOGRAM_BOUNDARIES;

// Enums. A provisional enum was authored from the specification text, not from KYA.

/** KYA deployment profile. Unknown values: rejected. */
export const PROFILE = ["demo", "development", "production"] as const;
export type Profile = (typeof PROFILE)[number];

/** Generic success or failure outcome. Unknown values: rejected. */
export const RESULT = ["success", "failure"] as const;
export type Result = (typeof RESULT)[number];

/** Boundary decision outcome. Fail-closed cases are deny with a reason. Unknown values: rejected. */
export const DECISION = ["allow", "deny"] as const;
export type Decision = (typeof DECISION)[number];

/** Signal that stopped a process. Unknown values: mapped to `other`. */
export const SHUTDOWN_SIGNAL = ["SIGTERM", "SIGINT", "other"] as const;
export type ShutdownSignal = (typeof SHUTDOWN_SIGNAL)[number];

/** Protected_Core state at process start and in the heartbeat. Provisional member list. Unknown values: mapped to `other`. */
export const CORE_STATE = ["verified", "degraded", "failed", "absent", "other"] as const;
export type CoreState = (typeof CORE_STATE)[number];

/** Why a component failed closed at start-up. Provisional member list. Unknown values: mapped to `other`. */
export const START_FAILURE_REASON = ["core_missing", "core_integrity_failed", "config_invalid", "key_unavailable", "dependency_unavailable", "other"] as const;
export type StartFailureReason = (typeof START_FAILURE_REASON)[number];

/** Frozen KYA BOUNDARY_REASON set, shown by its stable code. Unexpected values map to other. Provisional member list. Unknown values: mapped to `other`. */
export const BOUNDARY_REASON = ["allowed", "operational_boundary_exceeded", "capability_not_granted", "tier_insufficient", "delegation_invalid", "task_context_invalid", "credentials_invalid", "agent_revoked", "agent_suspended", "principal_inactive", "replay_detected", "tool_not_configured", "decision_unavailable", "decision_unverifiable", "decision_principal_mismatch", "token_invalid", "token_expired", "unknown_agent", "identity_revoked", "agent_deprovisioned", "principal_unverified", "identity_owner_deprovisioned", "credential_suspended", "credential_revoked", "credential_invalid", "request_mismatch", "gateway_unauthenticated", "gateway_not_approved", "operation_not_configured", "policy_missing", "policy_unavailable", "policy_unverifiable", "policy_mismatch", "policy_expired", "policy_unsupported_version", "policy_unsupported_control_member", "control_operation_denied", "control_target_denied", "control_argument_denied", "control_outside_time_window", "control_idempotency_required", "control_approval_required", "control_task_context_required", "control_delegation_denied", "control_environment_denied", "control_rate_limited", "control_budget_exceeded", "control_concurrency_exceeded", "control_egress_denied", "control_state_unavailable", "receipt_unavailable", "upstream_error", "upstream_timeout", "upstream_outcome_unknown", "passport_unavailable", "passport_invalid", "passport_revoked", "passport_mismatch", "other"] as const;
export type BoundaryReason = (typeof BOUNDARY_REASON)[number];

/** Assurance tier (ais_tier, tier, required_tier). Provisional member list. Unknown values: mapped to `other`. */
export const TIER = ["standard", "elevated", "other"] as const;
export type Tier = (typeof TIER)[number];

/** Gateway enforcement mode. `open` forwards callers that are not verified; `enforce` requires a verified token and proof. `observe` is retained for backward compatibility with contract 1.5 but is not a selectable Phase-4 mode. Adaptive is deliberately absent. Unknown values: mapped to `other`. */
export const GATEWAY_MODE = ["open", "enforce", "observe", "other"] as const;
export type GatewayMode = (typeof GATEWAY_MODE)[number];

/** Why the Gateway did or did not establish a verified agent identity for a call. Unknown values: mapped to `other`. */
export const GATEWAY_VERIFICATION = ["verified", "missing_token", "invalid_token", "token_expired", "missing_proof", "invalid_proof", "decision_unavailable", "policy_denied", "other"] as const;
export type GatewayVerification = (typeof GATEWAY_VERIFICATION)[number];

/** Outcome of the Gateway's attempt to mediate one source-to-target call. Unknown values: mapped to `other`. */
export const GATEWAY_ACCESS_OUTCOME = ["forwarded", "refused", "upstream_error", "upstream_timeout", "other"] as const;
export type GatewayAccessOutcome = (typeof GATEWAY_ACCESS_OUTCOME)[number];

/** Kind of target the Gateway mediated without carrying a URL or other sensitive value. Unknown values: mapped to `other`. */
export const GATEWAY_TARGET_KIND = ["mcp_server", "http_service", "other"] as const;
export type GatewayTargetKind = (typeof GATEWAY_TARGET_KIND)[number];

/** Whether the source identity was verified, merely claimed, or unavailable. Unknown values: mapped to `other`. */
export const GATEWAY_SOURCE_KIND = ["verified_agent", "claimed_agent", "unidentified", "other"] as const;
export type GatewaySourceKind = (typeof GATEWAY_SOURCE_KIND)[number];

/** The Gateway's view of the caller's Oathera Passport for one mediated call. `ok` is a valid, current Passport; `warn` is a Passport problem the Gateway did not deny on (open mode); `unavailable` means no Passport could be obtained; `pending` means the check had not completed. Carries no Passport content, name or principal reference. Added in 1.7. Unknown values: mapped to `other`. */
export const PASSPORT_STATE = ["ok", "warn", "unavailable", "pending", "other"] as const;
export type PassportState = (typeof PASSPORT_STATE)[number];

/** Agent status as seen by a decision, and the label of the agent-count gauge. Provisional member list. Unknown values: mapped to `other`. */
export const AGENT_STATUS = ["pending", "active", "suspended", "revoked", "deleted", "unknown", "other"] as const;
export type AgentStatus = (typeof AGENT_STATUS)[number];

/** Principal status as seen by a decision. Provisional member list. Unknown values: mapped to `other`. */
export const PRINCIPAL_STATUS = ["active", "suspended", "deprovisioned", "unknown", "other"] as const;
export type PrincipalStatus = (typeof PRINCIPAL_STATUS)[number];

/** Gateway pipeline stage in which a decision was made or failed (FR-5.3). Provisional member list. Unknown values: mapped to `other`. */
export const GATEWAY_STAGE = ["parse", "credentials", "decision_request", "decision_verify", "authorize", "handler", "forward", "other"] as const;
export type GatewayStage = (typeof GATEWAY_STAGE)[number];

/** Gateway internal error code. Provisional member list. Unknown values: mapped to `other`. */
export const GATEWAY_ERROR_CODE = ["gateway_audit_failure", "decision_client_error", "handler_exception", "config_invalid", "other"] as const;
export type GatewayErrorCode = (typeof GATEWAY_ERROR_CODE)[number];

/** Why the AIS rejected a POST /gateway/decision request. Provisional member list. Unknown values: mapped to `other`. */
export const GATEWAY_REJECTION_REASON = ["invalid_request", "signature_invalid", "unknown_gateway", "binding_mismatch", "replayed", "body_too_large", "rate_limited", "other"] as const;
export type GatewayRejectionReason = (typeof GATEWAY_REJECTION_REASON)[number];

/** Why the Gateway MCP treated a caller as unidentified and refused the call. invalid_token is also a generic Gateway denial code; within this event it means "no identity token presented". Unknown values: mapped to `other`. */
export const GATEWAY_UNIDENTIFIED_REASON = ["invalid_token", "missing_identity", "other"] as const;
export type GatewayUnidentifiedReason = (typeof GATEWAY_UNIDENTIFIED_REASON)[number];

/** MCP transport a Gateway MCP call arrived on. Unknown values: mapped to `other`. */
export const GATEWAY_TRANSPORT = ["stdio", "http", "sse", "other"] as const;
export type GatewayTransport = (typeof GATEWAY_TRANSPORT)[number];

/** Identity MCP operation class. Unknown values: rejected. */
export const IDENTITY_MCP_OPERATION = ["enroll", "sign", "refresh"] as const;
export type IdentityMcpOperation = (typeof IDENTITY_MCP_OPERATION)[number];

/** How an agent enrolled. Unknown values: rejected. */
export const ENROLLMENT_METHOD = ["oidc", "spiffe"] as const;
export type EnrollmentMethod = (typeof ENROLLMENT_METHOD)[number];

/** Enrolment funnel stage (FR-4.1) plus the two terminal failures. Provisional member list. Unknown values: rejected. */
export const ENROLLMENT_STAGE = ["start", "poll", "activated", "bound", "denied", "rejected"] as const;
export type EnrollmentStage = (typeof ENROLLMENT_STAGE)[number];

/** Policy denial reason for enrolment, token issuance and federation. `none` is for metric labels of successful outcomes. Provisional member list. Unknown values: mapped to `other`. */
export const DENIAL_REASON = ["none", "policy_denied", "owner_not_eligible", "agent_unknown", "agent_revoked", "agent_suspended", "host_untrusted", "audience_not_allowed", "version_unsupported", "rate_limited", "dependency_unavailable", "other"] as const;
export type DenialReason = (typeof DENIAL_REASON)[number];

/** Why an OIDC enrolment callback was rejected. Provisional member list. Unknown values: mapped to `other`. */
export const CALLBACK_REJECTION_REASON = ["state_mismatch", "state_expired", "nonce_mismatch", "issuer_mismatch", "code_invalid", "replayed", "other"] as const;
export type CallbackRejectionReason = (typeof CALLBACK_REJECTION_REASON)[number];

/** Why a SPIFFE enrolment was rejected. Provisional member list. Unknown values: mapped to `other`. */
export const SPIFFE_REJECTION_REASON = ["challenge_expired", "challenge_mismatch", "svid_invalid", "trust_domain_mismatch", "signature_invalid", "replayed", "other"] as const;
export type SpiffeRejectionReason = (typeof SPIFFE_REJECTION_REASON)[number];

/** Kind of token issued. Unknown values: rejected. */
export const TOKEN_KIND = ["agent", "federation"] as const;
export type TokenKind = (typeof TOKEN_KIND)[number];

/** Token issuance outcome. Unknown values: rejected. */
export const TOKEN_OUTCOME = ["issued", "denied"] as const;
export type TokenOutcome = (typeof TOKEN_OUTCOME)[number];

/** Who revoked an agent. Provisional member list. Unknown values: mapped to `other`. */
export const ACTOR_TYPE = ["owner", "admin", "system", "agent", "other"] as const;
export type ActorType = (typeof ACTOR_TYPE)[number];

/** Confidence in the host fingerprint. Provisional member list. Unknown values: mapped to `other`. */
export const HOST_CONFIDENCE = ["unknown", "low", "medium", "high", "other"] as const;
export type HostConfidence = (typeof HOST_CONFIDENCE)[number];

/** Strength of host attestation. Provisional member list. Unknown values: mapped to `other`. */
export const HOST_ATTESTATION = ["none", "software", "hardware", "other"] as const;
export type HostAttestation = (typeof HOST_ATTESTATION)[number];

/** What changed about a host. Provisional member list. Unknown values: mapped to `other`. */
export const HOST_CHANGE_KIND = ["fingerprint", "confidence", "attestation", "other"] as const;
export type HostChangeKind = (typeof HOST_CHANGE_KIND)[number];

/** Agent lifecycle action counted by the AIS (FR-4.3). Unknown values: rejected. */
export const AGENT_LIFECYCLE_ACTION = ["revoke", "suspend", "reinstate", "deprovision", "delete", "anchor_rotate"] as const;
export type AgentLifecycleAction = (typeof AGENT_LIFECYCLE_ACTION)[number];

/** Why the VCI could not be used. Provisional member list. Unknown values: mapped to `other`. */
export const VCI_UNAVAILABLE_REASON = ["timeout", "connection_failed", "non_2xx", "invalid_response", "circuit_open", "other"] as const;
export type VciUnavailableReason = (typeof VCI_UNAVAILABLE_REASON)[number];

/** What a rotated key signs. Provisional member list. Unknown values: mapped to `other`. */
export const KEY_PURPOSE = ["token", "decision", "credential", "audit", "other"] as const;
export type KeyPurpose = (typeof KEY_PURPOSE)[number];

/** Whether a Resource Server request came directly or through a Gateway. Unknown values: rejected. */
export const VERIFICATION_PATH = ["direct", "gateway"] as const;
export type VerificationPath = (typeof VERIFICATION_PATH)[number];

/** Resource Server verification error code. `none` is for metric labels of successful outcomes. Provisional member list. Unknown values: mapped to `other`. */
export const VERIFICATION_ERROR_CODE = ["none", "invalid_token", "token_expired", "invalid_proof", "proof_replayed", "audience_mismatch", "invalid_assertion", "agent_revoked", "other"] as const;
export type VerificationErrorCode = (typeof VERIFICATION_ERROR_CODE)[number];

/** Verifiable credential format. Provisional member list. Unknown values: mapped to `other`. */
export const CREDENTIAL_FORMAT = ["jwt_vc", "sd_jwt_vc", "other"] as const;
export type CredentialFormat = (typeof CREDENTIAL_FORMAT)[number];

/** VCI credential operation counted by the credential counter. Unknown values: rejected. */
export const CREDENTIAL_ACTION = ["issue", "record"] as const;
export type CredentialAction = (typeof CREDENTIAL_ACTION)[number];

/** VCI administrative lifecycle action. Unknown values: rejected. */
export const CREDENTIAL_LIFECYCLE_ACTION = ["suspend", "reinstate", "revoke"] as const;
export type CredentialLifecycleAction = (typeof CREDENTIAL_LIFECYCLE_ACTION)[number];

/** Why a credential could not be persisted. Provisional member list. Unknown values: mapped to `other`. */
export const CREDENTIAL_PERSIST_REASON = ["write_failed", "serialization_failed", "storage_unavailable", "other"] as const;
export type CredentialPersistReason = (typeof CREDENTIAL_PERSIST_REASON)[number];

/** Result of a credential status lookup. Provisional member list. Unknown values: mapped to `other`. */
export const STATUS_LOOKUP_RESULT = ["active", "suspended", "revoked", "not_found", "unavailable", "error", "other"] as const;
export type StatusLookupResult = (typeof STATUS_LOOKUP_RESULT)[number];

/** Operation safety class used by the outage policy. Provisional member list. Unknown values: mapped to `other`. */
export const SAFETY_CLASS = ["read_only", "standard", "high_risk", "other"] as const;
export type SafetyClass = (typeof SAFETY_CLASS)[number];

/** Status of the dependency behind an outage decision. Provisional member list. Unknown values: mapped to `other`. */
export const DEPENDENCY_STATUS = ["available", "degraded", "unavailable", "unknown", "other"] as const;
export type DependencyStatus = (typeof DEPENDENCY_STATUS)[number];

/** Outage policy mode. Provisional member list. Unknown values: mapped to `other`. */
export const OUTAGE_MODE = ["fail_closed", "fail_open", "degraded", "other"] as const;
export type OutageMode = (typeof OUTAGE_MODE)[number];

/** Reason code of an outage decision. Provisional member list. Unknown values: mapped to `other`. */
export const OUTAGE_REASON = ["dependency_unavailable", "dependency_degraded", "policy_fail_closed", "policy_fail_open", "other"] as const;
export type OutageReason = (typeof OUTAGE_REASON)[number];

/** Replay store namespace. Closed so that zero values can always be shown (FR-5.2). Provisional member list. Unknown values: mapped to `other`. */
export const REPLAY_NAMESPACE = ["operation_proof", "gateway_assertion", "identity_token", "decision", "enrollment", "other"] as const;
export type ReplayNamespace = (typeof REPLAY_NAMESPACE)[number];

/** Rate-limited surface. Provisional member list. Unknown values: mapped to `other`. */
export const RATELIMIT_SURFACE = ["enrollment", "token", "decision", "admin", "other"] as const;
export type RatelimitSurface = (typeof RATELIMIT_SURFACE)[number];

/** Rate limiter outcome. Unknown values: rejected. */
export const RATELIMIT_OUTCOME = ["allowed", "limited"] as const;
export type RatelimitOutcome = (typeof RATELIMIT_OUTCOME)[number];

/** AUDIT_INTEGRITY_REASONS, the reasons an AuditIntegrityLog raises its alert hook. Provisional member list. Unknown values: mapped to `other`. */
export const AUDIT_ALERT = ["chain_broken", "seal_failed", "export_failed", "export_lag", "retention_blocked", "other"] as const;
export type AuditAlert = (typeof AUDIT_ALERT)[number];

/** PROTECTED_CORE_REASON, closed set of Protected_Core failure codes. Provisional member list. Unknown values: mapped to `other`. */
export const CORE_FAILURE_REASON = ["core_missing", "hash_mismatch", "signature_invalid", "load_failed", "target_mismatch", "other"] as const;
export type CoreFailureReason = (typeof CORE_FAILURE_REASON)[number];

/** What triggered a Protected_Core integrity check. Provisional member list. Unknown values: mapped to `other`. */
export const CORE_TRIGGER = ["startup", "periodic", "on_demand", "other"] as const;
export type CoreTrigger = (typeof CORE_TRIGGER)[number];

/** Kind of posture finding source. Unknown values: rejected. */
export const POSTURE_KIND = ["nhi", "host"] as const;
export type PostureKind = (typeof POSTURE_KIND)[number];

/** Posture finding code. Provisional member list. Unknown values: mapped to `other`. */
export const FINDING_CODE = ["improper_offboarding", "overprivileged", "long_lived_credentials", "stale_identity", "unowned_identity", "host_changed", "host_low_confidence", "host_unattested", "other"] as const;
export type FindingCode = (typeof FINDING_CODE)[number];

/** Posture risk tier. Provisional member list. Unknown values: mapped to `other`. */
export const RISK_TIER = ["low", "medium", "high", "critical", "other"] as const;
export type RiskTier = (typeof RISK_TIER)[number];

/** HTTP status class. Unknown values: rejected. */
export const STATUS_CLASS = ["1xx", "2xx", "3xx", "4xx", "5xx"] as const;
export type StatusClass = (typeof STATUS_CLASS)[number];

/** Target of an outbound call. Unknown values: rejected. */
export const CLIENT_TARGET = ["idp", "ais", "vci", "resource", "oidc", "jwks"] as const;
export type ClientTarget = (typeof CLIENT_TARGET)[number];

/** Outbound call outcome (instr 5.3 names timeout, non_200 and unverifiable). Unknown values: mapped to `other`. */
export const CLIENT_OUTCOME = ["ok", "timeout", "non_200", "unverifiable", "error", "other"] as const;
export type ClientOutcome = (typeof CLIENT_OUTCOME)[number];

/** Signal type in the telemetry drop counter. Unknown values: rejected. */
export const TELEMETRY_SIGNAL = ["events", "spans", "metric_points"] as const;
export type TelemetrySignal = (typeof TELEMETRY_SIGNAL)[number];

/** Why a telemetry item was dropped or altered. Also the key set of batch.dropped.by_reason. Unknown values: mapped to `other`. */
export const DROP_REASON = ["unknown_event", "unknown_metric", "emitter_mismatch", "attr_rejected", "event_rejected", "label_rejected", "series_cap", "enum_mapped", "credential_shaped", "buffer_full", "breaker_open", "shutdown", "other"] as const;
export type DropReason = (typeof DROP_REASON)[number];

/** Outcome of a telemetry send. Unknown values: mapped to `other`. */
export const SEND_OUTCOME = ["ok", "failed", "timeout", "rejected", "breaker_open", "other"] as const;
export type SendOutcome = (typeof SEND_OUTCOME)[number];

/** Outcome of a forwarded MCP tool call. Unknown values: mapped to `other`. */
export const TOOL_OUTCOME = ["ok", "tool_error", "upstream_error", "timeout", "cancelled", "other"] as const;
export type ToolOutcome = (typeof TOOL_OUTCOME)[number];

/** Coarse size bucket for a tool result payload. Unknown values: mapped to `other`. */
export const SIZE_BUCKET = ["lt_1k", "lt_10k", "lt_100k", "lt_1m", "ge_1m", "other"] as const;
export type SizeBucket = (typeof SIZE_BUCKET)[number];

/** Kind of change to a tool's surface versus the last snapshot. Unknown values: mapped to `other`. */
export const SURFACE_CHANGE = ["snapshot", "added", "removed", "description_changed", "schema_changed", "other"] as const;
export type SurfaceChange = (typeof SURFACE_CHANGE)[number];

/** Whether a surfaced tool has enforcement configured (string form of a bool, for a label). Unknown values: mapped to `other`. */
export const ENFORCED_STATE = ["enforced", "unenforced", "other"] as const;
export type EnforcedState = (typeof ENFORCED_STATE)[number];

/** Where an assurance scan ran. Unknown values: mapped to `other`. */
export const ASSURANCE_SURFACE = ["agent_tool", "inline_guard", "ci", "repo", "other"] as const;
export type AssuranceSurface = (typeof ASSURANCE_SURFACE)[number];

/** Scope of an assurance scan. Unknown values: mapped to `other`. */
export const ASSURANCE_SCOPE = ["snippet", "session_diff", "full_repo", "mcp_server", "other"] as const;
export type AssuranceScope = (typeof ASSURANCE_SCOPE)[number];

/** Overall verdict of an assurance scan. Unknown values: mapped to `other`. */
export const ASSURANCE_VERDICT = ["pass", "advisory", "block", "error", "other"] as const;
export type AssuranceVerdict = (typeof ASSURANCE_VERDICT)[number];

/** Assurance gate mode. Unknown values: mapped to `other`. */
export const ASSURANCE_GATE_MODE = ["observe", "advisory", "gate", "strict", "other"] as const;
export type AssuranceGateMode = (typeof ASSURANCE_GATE_MODE)[number];

/** Engine that produced an assurance finding. Unknown values: mapped to `other`. */
export const ASSURANCE_ENGINE = ["sast", "secrets", "sca", "iac", "sbom", "mcp_surface", "other"] as const;
export type AssuranceEngine = (typeof ASSURANCE_ENGINE)[number];

/** Severity of an assurance finding. Unknown values: mapped to `other`. */
export const FINDING_SEVERITY = ["critical", "high", "medium", "low", "info", "other"] as const;
export type FindingSeverity = (typeof FINDING_SEVERITY)[number];

/** Lifecycle status of an assurance finding. Unknown values: mapped to `other`. */
export const FINDING_STATUS = ["open", "fixed", "accepted", "false_positive", "other"] as const;
export type FindingStatus = (typeof FINDING_STATUS)[number];

/** Decision taken on an assurance finding. Unknown values: mapped to `other`. */
export const ASSURANCE_ACTION = ["allow", "advisory", "block", "exception_requested", "exception_granted", "fix_verified", "other"] as const;
export type AssuranceAction = (typeof ASSURANCE_ACTION)[number];

/** Identity MCP tool invoked. Matches the identity-server tool dispatch set. Unknown values: mapped to `other`. */
export const IDENTITY_MCP_TOOL = ["enroll", "issue_token", "status", "sign_request", "sign_operation", "get_passport", "other"] as const;
export type IdentityMcpTool = (typeof IDENTITY_MCP_TOOL)[number];

/** Transport an Identity MCP tool call arrived on. Unknown values: mapped to `other`. */
export const IDENTITY_MCP_TRANSPORT = ["stdio", "http", "other"] as const;
export type IdentityMcpTransport = (typeof IDENTITY_MCP_TRANSPORT)[number];

/** Identity MCP denial/failure reason code (failures only). Unknown values: mapped to `other`. */
export const IDENTITY_MCP_REASON = ["activation_verification_failed", "agent_suspended", "ambiguous_binding", "anchor_mismatch", "approval_mismatch", "approval_replayed", "approval_required", "approval_store_unavailable", "attribute_elicitation_cancel", "attribute_elicitation_decline", "attribute_elicitation_failed", "audience_expansion", "bearer_auth_forbidden", "bearer_invalid", "bearer_missing", "binding_incomplete", "binding_required", "capability_expansion", "core_integrity_failed", "core_unavailable", "delegation_cycle", "depth_exceeded", "expired_activation", "expired_approval", "expired_context", "expired_delegation", "expired_token", "host_changed", "insufficient_capability", "internal", "invalid_activation", "invalid_allowlist", "invalid_approval", "invalid_audience", "invalid_context", "invalid_credential_id", "invalid_delegation", "invalid_operation", "invalid_operation_arguments", "invalid_operation_proof", "invalid_session_manager", "invalid_signature", "invalid_tenant", "invalid_token", "invalid_token_binding", "issuance_failed", "lifetime_expansion", "mtls_client_unauthorized", "no_session_key", "no_token", "peer_credentials_unverified", "platform_identity_unverified", "policy_denied", "rate_limited", "revoked", "session_expired", "sign_request_denied", "sign_request_disabled", "subject_mismatch", "temporarily_unavailable", "tenant_mismatch", "timeout", "token_refresh_required", "unauthenticated", "unknown_key", "unmapped_credential", "unsupported_auth_mode", "unsupported_version", "untrusted_issuer", "policy_missing", "policy_unavailable", "policy_unverifiable", "policy_mismatch", "policy_expired", "policy_unsupported_version", "policy_unsupported_control_member", "control_operation_denied", "control_target_denied", "control_argument_denied", "control_outside_time_window", "control_idempotency_required", "control_approval_required", "control_task_context_required", "control_delegation_denied", "passport_unavailable", "passport_invalid", "passport_revoked", "passport_mismatch", "other"] as const;
export type IdentityMcpReason = (typeof IDENTITY_MCP_REASON)[number];

/** What happens to a value outside the set: `other` maps it and counts `enum_mapped`, `drop` rejects it. */
export const ENUM_ON_UNKNOWN = {
  profile: "drop",
  result: "drop",
  decision: "drop",
  shutdown_signal: "other",
  core_state: "other",
  start_failure_reason: "other",
  boundary_reason: "other",
  tier: "other",
  gateway_mode: "other",
  gateway_verification: "other",
  gateway_access_outcome: "other",
  gateway_target_kind: "other",
  gateway_source_kind: "other",
  passport_state: "other",
  agent_status: "other",
  principal_status: "other",
  gateway_stage: "other",
  gateway_error_code: "other",
  gateway_rejection_reason: "other",
  gateway_unidentified_reason: "other",
  gateway_transport: "other",
  identity_mcp_operation: "drop",
  enrollment_method: "drop",
  enrollment_stage: "drop",
  denial_reason: "other",
  callback_rejection_reason: "other",
  spiffe_rejection_reason: "other",
  token_kind: "drop",
  token_outcome: "drop",
  actor_type: "other",
  host_confidence: "other",
  host_attestation: "other",
  host_change_kind: "other",
  agent_lifecycle_action: "drop",
  vci_unavailable_reason: "other",
  key_purpose: "other",
  verification_path: "drop",
  verification_error_code: "other",
  credential_format: "other",
  credential_action: "drop",
  credential_lifecycle_action: "drop",
  credential_persist_reason: "other",
  status_lookup_result: "other",
  safety_class: "other",
  dependency_status: "other",
  outage_mode: "other",
  outage_reason: "other",
  replay_namespace: "other",
  ratelimit_surface: "other",
  ratelimit_outcome: "drop",
  audit_alert: "other",
  core_failure_reason: "other",
  core_trigger: "other",
  posture_kind: "drop",
  finding_code: "other",
  risk_tier: "other",
  status_class: "drop",
  client_target: "drop",
  client_outcome: "other",
  telemetry_signal: "drop",
  drop_reason: "other",
  send_outcome: "other",
  tool_outcome: "other",
  size_bucket: "other",
  surface_change: "other",
  enforced_state: "other",
  assurance_surface: "other",
  assurance_scope: "other",
  assurance_verdict: "other",
  assurance_gate_mode: "other",
  assurance_engine: "other",
  finding_severity: "other",
  finding_status: "other",
  assurance_action: "other",
  identity_mcp_tool: "other",
  identity_mcp_transport: "other",
  identity_mcp_reason: "other",
} as const;
export type EnumName = keyof typeof ENUM_ON_UNKNOWN;

// Events

export const EVENT_NAMES = ["process_start", "process_start_failed", "process_stop", "oidc_authorize", "oidc_token_exchange", "enrollment_start", "enrollment_approved", "enrollment_policy_denied", "enrollment_callback_rejected", "spiffe_challenge_issued", "spiffe_enrollment", "spiffe_enrollment_rejected", "token_issuance", "token_issuance_denied", "federation_token_denied", "agent_verification", "agent_revoked", "agent_deleted", "owner_deprovisioned", "anchor_rotated", "host_change", "vci_unavailable", "gateway_decision_rejected", "boundary_decision", "gateway_access_observation", "gateway_unenforced_call", "gateway_unidentified_call", "gateway_internal_error", "resource_verification", "credential_issued", "credential_lifecycle", "credential_persist_failed", "outage_decision", "audit_integrity_alert", "core_integrity_failed", "rate_limited", "key_rotated", "gateway_tool_outcome", "gateway_tool_surface", "assurance_scan", "assurance_finding", "assurance_decision", "identity_mcp_tool_call"] as const;
export type EventName = (typeof EVENT_NAMES)[number];

/** A process started. */
export interface ProcessStartAttrs {
  /** at most 64 characters; free text, credential-scanned */
  version: string;
  profile: Profile;
  core_state?: CoreState;
}

/** A component failed closed at start-up; sent best effort before exit. */
export interface ProcessStartFailedAttrs {
  reason_code: StartFailureReason;
}

/** A process is shutting down. */
export interface ProcessStopAttrs {
  signal: ShutdownSignal;
}

/** IDP authorization request handled. */
export interface OidcAuthorizeAttrs {
  /** at most 128 characters */
  client_id: string;
  outcome: Result;
}

/** IDP token exchange handled. The email is never sent. */
export interface OidcTokenExchangeAttrs {
  outcome: Result;
}

/** An agent enrolment began. */
export interface EnrollmentStartAttrs {
  anchor_jkt: string;
  ais_tier?: Tier;
  host_fingerprint?: `sha256-${string}`;
  host_confidence?: HostConfidence;
  host_attestation?: HostAttestation;
}

/** An enrolment was approved and the agent bound to a principal. */
export interface EnrollmentApprovedAttrs {
  /** at most 128 characters */
  agent_sub: string;
  method: EnrollmentMethod;
  principal_ref?: `principal:${string}`;
}

/** Enrolment policy denied an enrolment. */
export interface EnrollmentPolicyDeniedAttrs {
  reason: DenialReason;
  method?: EnrollmentMethod;
}

/** An OIDC enrolment callback was rejected. */
export interface EnrollmentCallbackRejectedAttrs {
  reason: CallbackRejectionReason;
}

/** A SPIFFE enrolment challenge was issued. */
export interface SpiffeChallengeIssuedAttrs {
  anchor_jkt: string;
}

/** A SPIFFE enrolment completed. */
export interface SpiffeEnrollmentAttrs {
  /** at most 128 characters */
  agent_sub: string;
}

/** A SPIFFE enrolment was rejected. */
export interface SpiffeEnrollmentRejectedAttrs {
  reason: SpiffeRejectionReason;
}

/** A token was issued. */
export interface TokenIssuanceAttrs {
  /** at most 128 characters */
  agent_sub: string;
  /** 0 to 1000 */
  version?: number;
  /** at most 128 characters */
  audience?: string;
  /** 0 to 31536000 */
  lifetime_s?: number;
  kind: TokenKind;
}

/** Token issuance was denied. */
export interface TokenIssuanceDeniedAttrs {
  /** at most 128 characters */
  agent_sub: string;
  reason: DenialReason;
  kind?: TokenKind;
}

/** A federation token was denied. */
export interface FederationTokenDeniedAttrs {
  /** at most 128 characters */
  agent_sub: string;
  reason: DenialReason;
}

/** An agent identity was verified. */
export interface AgentVerificationAttrs {
  /** at most 128 characters */
  agent_sub: string;
}

/** An agent was revoked. */
export interface AgentRevokedAttrs {
  /** at most 128 characters */
  agent_sub: string;
  actor_type?: ActorType;
}

/** An agent was deleted. */
export interface AgentDeletedAttrs {
  /** at most 128 characters */
  agent_sub: string;
}

/** An owner was deprovisioned; the number of affected agents is reported. */
export interface OwnerDeprovisionedAttrs {
  principal_ref: `principal:${string}`;
  /** 0 to 2147483647 */
  affected_agents?: number;
}

/** An agent anchor key was rotated. */
export interface AnchorRotatedAttrs {
  /** at most 128 characters */
  agent_sub: string;
  /** 0 to 2147483647 */
  key_epoch?: number;
}

/** The host of an agent changed. */
export interface HostChangeAttrs {
  /** at most 128 characters */
  agent_sub: string;
  change: HostChangeKind;
  host_confidence?: HostConfidence;
}

/** The VCI could not be reached or gave an unusable answer. */
export interface VciUnavailableAttrs {
  /** at most 128 characters */
  agent_sub?: string;
  reason_code: VciUnavailableReason;
}

/** The AIS rejected a POST /gateway/decision request. `detail` is a check name, not a path. */
export interface GatewayDecisionRejectedAttrs {
  /** 100 to 599 */
  status: number;
  reason: GatewayRejectionReason;
  /** at most 128 characters */
  gateway_id?: string;
  /** free text, credential-scanned */
  detail?: string;
}

/** A boundary decision. The AIS and the Gateway both emit it with the same decision_id; the control plane joins them (instr 8, rules.yaml decision_join). Deny decisions are never sampled. Allow decisions are sampled by hashing decision_id, so both sides keep or drop the same decision. */
export interface BoundaryDecisionAttrs {
  /** at most 128 characters */
  decision_id: string;
  decision: Decision;
  reason: BoundaryReason;
  /** at most 128 characters */
  operation?: string;
  /** at most 128 characters */
  capability?: string;
  /** at most 128 characters */
  audience?: string;
  tier?: Tier;
  required_tier?: Tier;
  /** at most 128 characters */
  agent_sub?: string;
  agent_status?: AgentStatus;
  principal_status?: PrincipalStatus;
  /** at most 128 characters */
  gateway_id?: string;
  credentials_checked?: boolean;
  signed?: boolean;
  mode?: GatewayMode;
  /** 0 to 86400000 */
  latency_ms?: number;
  /** sent by gateway-mcp only (required of them) */
  stage?: GatewayStage;
  /** at most 128 characters; sent by gateway-mcp only */
  tool?: string;
  /** sent by gateway-mcp only (required of them) */
  handler_invoked?: boolean;
  /** sent by gateway-mcp only */
  idempotent_replay?: boolean;
}

/** One source-to-target observation for every call the Gateway mediates, in open or enforce mode. It carries no token, proof, arguments, result, URL, principal or personal data. `agent_sub` is present only for a verified source; `claimed_sub` only for an unverified claim; neither is present for an unidentified caller. The emitter must keep those source-kind invariants. */
export interface GatewayAccessObservationAttrs {
  /** at most 128 characters */
  observation_id: string;
  /** at most 128 characters */
  gateway_id: string;
  mode: GatewayMode;
  source_kind: GatewaySourceKind;
  agent_verified: boolean;
  verification: GatewayVerification;
  /** at most 128 characters */
  agent_sub?: string;
  /** at most 128 characters */
  claimed_sub?: string;
  /** at most 128 characters */
  target_id: string;
  target_kind: GatewayTargetKind;
  /** at most 128 characters */
  operation?: string;
  /** at most 128 characters */
  tool?: string;
  outcome: GatewayAccessOutcome;
  /** at most 128 characters */
  decision_id?: string;
  /** 0 to 86400000 */
  latency_ms?: number;
  passport_state?: PassportState;
}

/** A tool call the Gateway did not enforce. */
export interface GatewayUnenforcedCallAttrs {
  decision: Decision;
  reason: BoundaryReason;
  /** at most 128 characters */
  tool?: string;
  configured?: boolean;
  default_deny?: boolean;
}

/** The Gateway MCP refused a tool call because the caller presented no usable identity. Carries no token, authorization header or call arguments. tenant is the Gateway's own claim; the authoritative tenant is the batch's resource.tenant_id. */
export interface GatewayUnidentifiedCallAttrs {
  refusal_reason: GatewayUnidentifiedReason;
  transport?: GatewayTransport;
  /** at most 128 characters */
  tenant?: string;
  /** at most 128 characters */
  tool?: string;
  /** at most 128 characters */
  gateway_id?: string;
  /** at most 128 characters; free text, credential-scanned */
  client_name?: string;
  /** at most 64 characters; free text, credential-scanned */
  client_version?: string;
  /** at most 64 characters; free text, credential-scanned */
  source_addr?: string;
  caller_key?: `sha256-${string}`;
}

/** A Gateway internal error. */
export interface GatewayInternalErrorAttrs {
  code: GatewayErrorCode;
}

/** Resource Server verification outcome. principal_email and error_description are never sent. Failures are never sampled. */
export interface ResourceVerificationAttrs {
  outcome: Result;
  error_code?: VerificationErrorCode;
  path: VerificationPath;
  /** at most 128 characters */
  agent_sub?: string;
  principal_ref?: `principal:${string}`;
}

/** A credential was issued. */
export interface CredentialIssuedAttrs {
  format: CredentialFormat;
  outcome: Result;
}

/** An administrative credential lifecycle action. */
export interface CredentialLifecycleAttrs {
  action: CredentialLifecycleAction;
  credential_ref?: `cred:${string}`;
}

/** A credential could not be persisted. */
export interface CredentialPersistFailedAttrs {
  reason_code: CredentialPersistReason;
}

/** The outage policy decided for an operation while a dependency was unavailable. */
export interface OutageDecisionAttrs {
  /** at most 128 characters */
  operation: string;
  safety_class?: SafetyClass;
  dependency_status?: DependencyStatus;
  decision: Decision;
  reason_code?: OutageReason;
}

/** An AuditIntegrityLog raised its alert hook. Emitted by components that instantiate one. */
export interface AuditIntegrityAlertAttrs {
  alert: AuditAlert;
  /** 0 to 2147483647 */
  batch_seq?: number;
  /** 0 to 2147483647 */
  seq?: number;
}

/** Protected_Core integrity verification failed. */
export interface CoreIntegrityFailedAttrs {
  reason_code: CoreFailureReason;
  trigger?: CoreTrigger;
}

/** A request was rate limited. The limiter bucket key is never sent. */
export interface RateLimitedAttrs {
  surface: RatelimitSurface;
}

/** A signing key was rotated. */
export interface KeyRotatedAttrs {
  /** at most 128 characters */
  kid: string;
  purpose: KeyPurpose;
}

/** One per forwarded tool call, after the upstream handler returns or fails. */
export interface GatewayToolOutcomeAttrs {
  /** at most 128 characters */
  decision_id: string;
  /** at most 128 characters */
  tool?: string;
  outcome: ToolOutcome;
  /** 0 to 86400000 */
  duration_ms?: number;
  result_bytes_bucket?: SizeBucket;
  /** at most 128 characters */
  agent_sub?: string;
  /** at most 128 characters */
  gateway_id?: string;
}

/** Emitted on tool-surface snapshot/startup/24h and on add/remove/description/schema change. */
export interface GatewayToolSurfaceAttrs {
  /** at most 128 characters */
  upstream_id: string;
  /** at most 128 characters */
  tool: string;
  change: SurfaceChange;
  description_hash?: `sha256-${string}`;
  schema_hash?: `sha256-${string}`;
  enforced?: boolean;
  default_deny?: boolean;
}

/** An assurance scan completed. */
export interface AssuranceScanAttrs {
  /** at most 128 characters */
  scan_id: string;
  /** at most 128 characters */
  decision_id?: string;
  /** at most 128 characters */
  agent_sub?: string;
  surface?: AssuranceSurface;
  scope?: AssuranceScope;
  verdict: AssuranceVerdict;
  gate_mode?: AssuranceGateMode;
  /** at most 128 characters */
  policy_version?: string;
  /** 0 to 2147483647 */
  critical?: number;
  /** 0 to 2147483647 */
  high?: number;
  /** 0 to 2147483647 */
  medium?: number;
  /** 0 to 2147483647 */
  low?: number;
  /** 0 to 86400000 */
  duration_ms?: number;
  attestation?: `sha256-${string}`;
}

/** An assurance finding, deduped on fingerprint. */
export interface AssuranceFindingAttrs {
  /** at most 128 characters */
  scan_id: string;
  fingerprint: `sha256-${string}`;
  engine?: AssuranceEngine;
  /** at most 128 characters */
  rule_id?: string;
  /** at most 128 characters */
  cwe?: string;
  severity: FindingSeverity;
  status?: FindingStatus;
  file_ref?: `sha256-${string}`;
  /** at most 128 characters */
  agent_sub?: string;
}

/** A decision taken on an assurance finding. */
export interface AssuranceDecisionAttrs {
  /** at most 128 characters */
  scan_id?: string;
  fingerprint?: `sha256-${string}`;
  action: AssuranceAction;
  actor_type?: ActorType;
  /** at most 128 characters */
  agent_sub?: string;
}

/** Identity MCP tool outcome and reason (opt-in, customer side; instr 5.7). Carries no agent, tenant, binding, audience, capability, arguments or resource ids. */
export interface IdentityMcpToolCallAttrs {
  tool: IdentityMcpTool;
  outcome: Result;
  reason?: IdentityMcpReason;
  /** 0 to 86400000 */
  duration_ms?: number;
  transport?: IdentityMcpTransport;
}

/** Attribute shape of each event. */
export interface EventAttrsMap {
  process_start: ProcessStartAttrs;
  process_start_failed: ProcessStartFailedAttrs;
  process_stop: ProcessStopAttrs;
  oidc_authorize: OidcAuthorizeAttrs;
  oidc_token_exchange: OidcTokenExchangeAttrs;
  enrollment_start: EnrollmentStartAttrs;
  enrollment_approved: EnrollmentApprovedAttrs;
  enrollment_policy_denied: EnrollmentPolicyDeniedAttrs;
  enrollment_callback_rejected: EnrollmentCallbackRejectedAttrs;
  spiffe_challenge_issued: SpiffeChallengeIssuedAttrs;
  spiffe_enrollment: SpiffeEnrollmentAttrs;
  spiffe_enrollment_rejected: SpiffeEnrollmentRejectedAttrs;
  token_issuance: TokenIssuanceAttrs;
  token_issuance_denied: TokenIssuanceDeniedAttrs;
  federation_token_denied: FederationTokenDeniedAttrs;
  agent_verification: AgentVerificationAttrs;
  agent_revoked: AgentRevokedAttrs;
  agent_deleted: AgentDeletedAttrs;
  owner_deprovisioned: OwnerDeprovisionedAttrs;
  anchor_rotated: AnchorRotatedAttrs;
  host_change: HostChangeAttrs;
  vci_unavailable: VciUnavailableAttrs;
  gateway_decision_rejected: GatewayDecisionRejectedAttrs;
  boundary_decision: BoundaryDecisionAttrs;
  gateway_access_observation: GatewayAccessObservationAttrs;
  gateway_unenforced_call: GatewayUnenforcedCallAttrs;
  gateway_unidentified_call: GatewayUnidentifiedCallAttrs;
  gateway_internal_error: GatewayInternalErrorAttrs;
  resource_verification: ResourceVerificationAttrs;
  credential_issued: CredentialIssuedAttrs;
  credential_lifecycle: CredentialLifecycleAttrs;
  credential_persist_failed: CredentialPersistFailedAttrs;
  outage_decision: OutageDecisionAttrs;
  audit_integrity_alert: AuditIntegrityAlertAttrs;
  core_integrity_failed: CoreIntegrityFailedAttrs;
  rate_limited: RateLimitedAttrs;
  key_rotated: KeyRotatedAttrs;
  gateway_tool_outcome: GatewayToolOutcomeAttrs;
  gateway_tool_surface: GatewayToolSurfaceAttrs;
  assurance_scan: AssuranceScanAttrs;
  assurance_finding: AssuranceFindingAttrs;
  assurance_decision: AssuranceDecisionAttrs;
  identity_mcp_tool_call: IdentityMcpToolCallAttrs;
}
export type EventAttrs<N extends EventName> = EventAttrsMap[N];

/** Severities each event may carry; the first is the default. */
export interface EventSeverityMap {
  process_start: "info";
  process_start_failed: "critical";
  process_stop: "info";
  oidc_authorize: "info";
  oidc_token_exchange: "info";
  enrollment_start: "info";
  enrollment_approved: "info";
  enrollment_policy_denied: "warn";
  enrollment_callback_rejected: "warn";
  spiffe_challenge_issued: "info";
  spiffe_enrollment: "info";
  spiffe_enrollment_rejected: "warn";
  token_issuance: "info";
  token_issuance_denied: "warn";
  federation_token_denied: "warn";
  agent_verification: "info";
  agent_revoked: "warn";
  agent_deleted: "warn";
  owner_deprovisioned: "warn";
  anchor_rotated: "info";
  host_change: "warn";
  vci_unavailable: "error";
  gateway_decision_rejected: "warn";
  boundary_decision: "info" | "warn";
  gateway_access_observation: "info" | "warn" | "error";
  gateway_unenforced_call: "warn";
  gateway_unidentified_call: "warn";
  gateway_internal_error: "error";
  resource_verification: "info" | "warn";
  credential_issued: "info";
  credential_lifecycle: "warn";
  credential_persist_failed: "error";
  outage_decision: "warn" | "error";
  audit_integrity_alert: "critical";
  core_integrity_failed: "critical";
  rate_limited: "warn";
  key_rotated: "info";
  gateway_tool_outcome: "info" | "warn" | "error";
  gateway_tool_surface: "info" | "warn" | "critical";
  assurance_scan: "info" | "warn";
  assurance_finding: "info" | "warn";
  assurance_decision: "info" | "warn";
  identity_mcp_tool_call: "info" | "warn";
}

/** Services allowed to send each event. */
export const EVENT_EMITTERS = {
  process_start: ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  process_start_failed: ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  process_stop: ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  oidc_authorize: ["idp"],
  oidc_token_exchange: ["idp"],
  enrollment_start: ["ais"],
  enrollment_approved: ["ais"],
  enrollment_policy_denied: ["ais"],
  enrollment_callback_rejected: ["ais"],
  spiffe_challenge_issued: ["ais"],
  spiffe_enrollment: ["ais"],
  spiffe_enrollment_rejected: ["ais"],
  token_issuance: ["ais"],
  token_issuance_denied: ["ais"],
  federation_token_denied: ["ais"],
  agent_verification: ["ais"],
  agent_revoked: ["ais"],
  agent_deleted: ["ais"],
  owner_deprovisioned: ["ais"],
  anchor_rotated: ["ais"],
  host_change: ["ais"],
  vci_unavailable: ["ais"],
  gateway_decision_rejected: ["ais"],
  boundary_decision: ["ais", "gateway-mcp"],
  gateway_access_observation: ["gateway-mcp"],
  gateway_unenforced_call: ["gateway-mcp"],
  gateway_unidentified_call: ["gateway-mcp"],
  gateway_internal_error: ["gateway-mcp"],
  resource_verification: ["resource"],
  credential_issued: ["vci"],
  credential_lifecycle: ["vci"],
  credential_persist_failed: ["vci"],
  outage_decision: ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  audit_integrity_alert: ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  core_integrity_failed: ["gateway-mcp", "identity-mcp"],
  rate_limited: ["ais"],
  key_rotated: ["ais", "vci", "gateway-mcp"],
  gateway_tool_outcome: ["gateway-mcp"],
  gateway_tool_surface: ["gateway-mcp"],
  assurance_scan: ["gateway-mcp"],
  assurance_finding: ["gateway-mcp"],
  assurance_decision: ["gateway-mcp"],
  identity_mcp_tool_call: ["identity-mcp"],
} as const satisfies Record<EventName, readonly Service[]>;

/** The wire form of an event (design 4.3). */
export interface TelemetryEvent<N extends EventName = EventName> {
  id: string;
  ts: number;
  name: N;
  severity: EventSeverityMap[N];
  sample_rate: number;
  trace_id?: string;
  span_id?: string;
  attrs: EventAttrsMap[N];
}
export type AnyTelemetryEvent = { [N in EventName]: TelemetryEvent<N> }[EventName];

// Metrics

export const METRIC_NAMES = ["oathera.http.server.duration", "oathera.http.client.duration", "oathera.gateway.decision.total", "oathera.gateway.decision.duration", "oathera.gateway.stage_failure.total", "oathera.ais.decision.total", "oathera.ais.decision.duration", "oathera.ais.token.total", "oathera.ais.enrollment.total", "oathera.ais.enrollment.duration", "oathera.identity_mcp.operation.total", "oathera.identity_mcp.operation.duration", "oathera.ais.agent.lifecycle.total", "oathera.ais.agents", "oathera.ais.ratelimit.total", "oathera.vci.status.lookup.duration", "oathera.vci.credential.total", "oathera.resource.verification.total", "oathera.replay.detected.total", "oathera.replay.store.saturation", "oathera.replay.store.ready", "oathera.outage.decision.total", "oathera.audit.unsealed", "oathera.audit.export.lag_s", "oathera.audit.integrity_alert.total", "oathera.core.integrity", "oathera.posture.findings", "oathera.telemetry.dropped.total", "oathera.telemetry.send.duration", "oathera.gateway.tool.total", "oathera.gateway.tool.duration", "oathera.gateway.tool_surface.tools", "oathera.gateway.assurance.scan.total", "oathera.gateway.assurance.finding.total", "oathera.gateway.assurance.scan.duration", "oathera.identity_mcp.denial.total"] as const;
export type MetricName = (typeof METRIC_NAMES)[number];
export type MetricKind = "counter" | "gauge" | "histogram";

export const METRIC_KIND = {
  "oathera.http.server.duration": "histogram",
  "oathera.http.client.duration": "histogram",
  "oathera.gateway.decision.total": "counter",
  "oathera.gateway.decision.duration": "histogram",
  "oathera.gateway.stage_failure.total": "counter",
  "oathera.ais.decision.total": "counter",
  "oathera.ais.decision.duration": "histogram",
  "oathera.ais.token.total": "counter",
  "oathera.ais.enrollment.total": "counter",
  "oathera.ais.enrollment.duration": "histogram",
  "oathera.identity_mcp.operation.total": "counter",
  "oathera.identity_mcp.operation.duration": "histogram",
  "oathera.ais.agent.lifecycle.total": "counter",
  "oathera.ais.agents": "gauge",
  "oathera.ais.ratelimit.total": "counter",
  "oathera.vci.status.lookup.duration": "histogram",
  "oathera.vci.credential.total": "counter",
  "oathera.resource.verification.total": "counter",
  "oathera.replay.detected.total": "counter",
  "oathera.replay.store.saturation": "gauge",
  "oathera.replay.store.ready": "gauge",
  "oathera.outage.decision.total": "counter",
  "oathera.audit.unsealed": "gauge",
  "oathera.audit.export.lag_s": "gauge",
  "oathera.audit.integrity_alert.total": "counter",
  "oathera.core.integrity": "gauge",
  "oathera.posture.findings": "gauge",
  "oathera.telemetry.dropped.total": "counter",
  "oathera.telemetry.send.duration": "histogram",
  "oathera.gateway.tool.total": "counter",
  "oathera.gateway.tool.duration": "histogram",
  "oathera.gateway.tool_surface.tools": "gauge",
  "oathera.gateway.assurance.scan.total": "counter",
  "oathera.gateway.assurance.finding.total": "counter",
  "oathera.gateway.assurance.scan.duration": "histogram",
  "oathera.identity_mcp.denial.total": "counter",
} as const satisfies Record<MetricName, MetricKind>;

/** Label shape of each metric. Labels are closed and all required. */
export interface MetricLabelsMap {
  "oathera.http.server.duration": { route: string; status_class: StatusClass };
  "oathera.http.client.duration": { target: ClientTarget; outcome: ClientOutcome };
  "oathera.gateway.decision.total": { outcome: Decision; reason: BoundaryReason; mode: GatewayMode };
  "oathera.gateway.decision.duration": { outcome: Decision };
  "oathera.gateway.stage_failure.total": { stage: GatewayStage; code: BoundaryReason };
  "oathera.ais.decision.total": { decision: Decision; reason: BoundaryReason; tier: Tier };
  "oathera.ais.decision.duration": { decision: Decision };
  "oathera.ais.token.total": { kind: TokenKind; version: string; outcome: TokenOutcome; reason: DenialReason };
  "oathera.ais.enrollment.total": { method: EnrollmentMethod; stage: EnrollmentStage };
  "oathera.ais.enrollment.duration": { method: EnrollmentMethod };
  "oathera.identity_mcp.operation.total": { kind: IdentityMcpOperation; outcome: Result };
  "oathera.identity_mcp.operation.duration": { kind: IdentityMcpOperation };
  "oathera.ais.agent.lifecycle.total": { action: AgentLifecycleAction };
  "oathera.ais.agents": { status: AgentStatus };
  "oathera.ais.ratelimit.total": { surface: RatelimitSurface; outcome: RatelimitOutcome };
  "oathera.vci.status.lookup.duration": { result: StatusLookupResult };
  "oathera.vci.credential.total": { action: CredentialAction; format: CredentialFormat };
  "oathera.resource.verification.total": { outcome: Result; error_code: VerificationErrorCode; path: VerificationPath };
  "oathera.replay.detected.total": { namespace: ReplayNamespace };
  "oathera.replay.store.saturation": Record<string, never>;
  "oathera.replay.store.ready": Record<string, never>;
  "oathera.outage.decision.total": { operation: string; mode: OutageMode };
  "oathera.audit.unsealed": Record<string, never>;
  "oathera.audit.export.lag_s": Record<string, never>;
  "oathera.audit.integrity_alert.total": { alert: AuditAlert };
  "oathera.core.integrity": Record<string, never>;
  "oathera.posture.findings": { kind: PostureKind; code: FindingCode; tier: RiskTier };
  "oathera.telemetry.dropped.total": { signal: TelemetrySignal; reason: DropReason };
  "oathera.telemetry.send.duration": { outcome: SendOutcome };
  "oathera.gateway.tool.total": { outcome: ToolOutcome };
  "oathera.gateway.tool.duration": { outcome: ToolOutcome };
  "oathera.gateway.tool_surface.tools": { enforced: EnforcedState };
  "oathera.gateway.assurance.scan.total": { verdict: AssuranceVerdict; surface: AssuranceSurface };
  "oathera.gateway.assurance.finding.total": { severity: FindingSeverity; engine: AssuranceEngine };
  "oathera.gateway.assurance.scan.duration": { surface: AssuranceSurface };
  "oathera.identity_mcp.denial.total": { tool: IdentityMcpTool; reason: IdentityMcpReason };
}
export type MetricLabels<N extends MetricName> = MetricLabelsMap[N];

/** Services allowed to send each metric. */
export const METRIC_EMITTERS = {
  "oathera.http.server.duration": ["idp", "ais", "vci", "resource", "gateway-mcp", "sim"],
  "oathera.http.client.duration": ["ais", "gateway-mcp", "vci"],
  "oathera.gateway.decision.total": ["gateway-mcp"],
  "oathera.gateway.decision.duration": ["gateway-mcp"],
  "oathera.gateway.stage_failure.total": ["gateway-mcp"],
  "oathera.ais.decision.total": ["ais"],
  "oathera.ais.decision.duration": ["ais"],
  "oathera.ais.token.total": ["ais"],
  "oathera.ais.enrollment.total": ["ais"],
  "oathera.ais.enrollment.duration": ["ais"],
  "oathera.identity_mcp.operation.total": ["identity-mcp"],
  "oathera.identity_mcp.operation.duration": ["identity-mcp"],
  "oathera.ais.agent.lifecycle.total": ["ais"],
  "oathera.ais.agents": ["ais"],
  "oathera.ais.ratelimit.total": ["ais"],
  "oathera.vci.status.lookup.duration": ["ais", "vci"],
  "oathera.vci.credential.total": ["vci"],
  "oathera.resource.verification.total": ["resource"],
  "oathera.replay.detected.total": ["ais", "resource", "gateway-mcp"],
  "oathera.replay.store.saturation": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.replay.store.ready": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.outage.decision.total": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.audit.unsealed": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.audit.export.lag_s": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.audit.integrity_alert.total": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.core.integrity": ["gateway-mcp", "identity-mcp"],
  "oathera.posture.findings": ["ais"],
  "oathera.telemetry.dropped.total": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.telemetry.send.duration": ["idp", "ais", "vci", "resource", "gateway-mcp", "identity-mcp", "sim"],
  "oathera.gateway.tool.total": ["gateway-mcp"],
  "oathera.gateway.tool.duration": ["gateway-mcp"],
  "oathera.gateway.tool_surface.tools": ["gateway-mcp"],
  "oathera.gateway.assurance.scan.total": ["gateway-mcp"],
  "oathera.gateway.assurance.finding.total": ["gateway-mcp"],
  "oathera.gateway.assurance.scan.duration": ["gateway-mcp"],
  "oathera.identity_mcp.denial.total": ["identity-mcp"],
} as const satisfies Record<MetricName, readonly Service[]>;

/** Boundary set of each histogram. */
export const METRIC_BOUNDARIES = {
  "oathera.http.server.duration": "default_ms",
  "oathera.http.client.duration": "default_ms",
  "oathera.gateway.decision.duration": "default_ms",
  "oathera.ais.decision.duration": "default_ms",
  "oathera.ais.enrollment.duration": "default_ms",
  "oathera.identity_mcp.operation.duration": "default_ms",
  "oathera.vci.status.lookup.duration": "default_ms",
  "oathera.telemetry.send.duration": "default_ms",
  "oathera.gateway.tool.duration": "default_ms",
  "oathera.gateway.assurance.scan.duration": "default_ms",
} as const satisfies Partial<Record<MetricName, HistogramBoundarySet>>;

/** A counter delta over the batch window. */
export interface CounterPoint<N extends MetricName = MetricName> {
  name: N;
  kind: "counter";
  labels: MetricLabelsMap[N];
  value: number;
}
export interface GaugePoint<N extends MetricName = MetricName> {
  name: N;
  kind: "gauge";
  unit?: string;
  labels: MetricLabelsMap[N];
  value: number;
}
/** Histogram deltas over the batch window; `buckets` has one more entry than the boundaries. */
export interface HistogramPoint<N extends MetricName = MetricName> {
  name: N;
  kind: "histogram";
  unit: "ms";
  labels: MetricLabelsMap[N];
  buckets: number[];
  count: number;
  sum: number;
}
export type AnyMetricPoint = CounterPoint | GaugePoint | HistogramPoint;
